module.exports = __webpack_public_path__ + "static/img/product3-2.c1b0676.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product3-2.jpg
// module id = Hf7A
// module chunks = 0